module.exports = __webpack_public_path__ + "static/MISSION10000_BATTERIES_Conference Proceedings-747f2c730d5e5ac7894febfb16f48dab.pdf";